export default __webpack_public_path__ + "static/hialgocase2-e8739156041f757c049ce9b7d4f9c5c8.png";